module.exports = __webpack_public_path__ + "img/HelpImage.f0c0c7bc.svg";